import { recommendData } from "@/mocks/anime";

export default function Recommend() {
  const primary = recommendData[0];
  const rest = recommendData.slice(1);

  return (
    <section id="recommend" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 md:mb-12 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-fire-fill"></i>
              追番推荐
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
              本周不容错过的热门新番
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              综合讨论热度、口碑与追番反馈，为你精选值得一看的高分作品。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
          {/* 主推大卡片 */}
          <article className="group relative overflow-hidden rounded-2xl bg-foreground-950 lg:col-span-1">
            <div className="relative h-full min-h-[420px] w-full">
              <img
                src={primary.image}
                alt={`${primary.title}本周热门追番推荐`}
                className="absolute inset-0 h-full w-full object-cover object-top opacity-90 transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/30 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-6">
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-star-fill"></i> 本周主推
                </span>
                <h3 className="mt-3 font-heading text-2xl text-background-50">{primary.title}</h3>
                <p className="mt-2 line-clamp-2 text-sm text-background-100/80">{primary.desc}</p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {primary.genre.map((g) => (
                    <span
                      key={g}
                      className="rounded-md bg-background-50/15 px-2 py-0.5 text-xs font-medium text-background-50"
                    >
                      {g}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </article>

          {/* 其余卡片流 */}
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:col-span-2 lg:grid-cols-2">
            {rest.map((item) => (
              <article
                key={item.id}
                className="group flex overflow-hidden rounded-2xl border border-background-200/80 bg-background-50 transition-all hover:-translate-y-1 hover:border-accent-300"
              >
                <div className="h-auto w-32 shrink-0 overflow-hidden sm:w-36">
                  <img
                    src={item.image}
                    alt={`${item.title}追番推荐`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col justify-center p-4">
                  <h3 className="font-heading text-lg text-foreground-950">{item.title}</h3>
                  <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                  <div className="mt-2.5 flex flex-wrap gap-1.5">
                    {item.genre.slice(0, 2).map((g) => (
                      <span
                        key={g}
                        className="rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800"
                      >
                        {g}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}